import { render, staticRenderFns } from "./AnnouncementsList.vue?vue&type=template&id=18d8c7fe&scoped=true"
import script from "./AnnouncementsList.vue?vue&type=script&lang=js"
export * from "./AnnouncementsList.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementsList.vue?vue&type=style&index=0&id=18d8c7fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8c7fe",
  null
  
)

export default component.exports